import axios from 'axios';
import Swal from 'sweetalert2';

// Apunta al backend Economías Colaborativas (mismo que RedJoven / Fenagro APL)
// Desarrollo: http://localhost:5246/api  |  Producción: ver .env
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5246/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

let alertaMostrada = false;

const mostrarAlertaErrorYRedirigir = (mensaje) => {
  if (!alertaMostrada) {
    alertaMostrada = true;
    if (window.location.pathname !== '/sin-conexion') {
      const rutaActual = window.location.pathname + window.location.search + window.location.hash;
      sessionStorage.setItem('rutaPreviaSinConexion', rutaActual);
    }
    Swal.fire({
      icon: 'error',
      title: 'Error de conexión',
      text: mensaje,
      confirmButtonText: 'Entendido',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      alertaMostrada = false;
      if (window.location.pathname !== '/sin-conexion') {
        window.location.href = '/sin-conexion';
      }
    });
  }
};

// Interceptor: agregar token de autenticación
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ecolab_token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor: manejar respuestas
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!navigator.onLine) {
      mostrarAlertaErrorYRedirigir('No hay conexión a internet. Verifica tu conexión e intenta nuevamente.');
      return Promise.reject(error);
    }
    if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message?.includes('Network Error')) {
      mostrarAlertaErrorYRedirigir('El servidor no está disponible en este momento. Por favor, intenta más tarde.');
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('ecolab_token');
      localStorage.removeItem('ecolab_user');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: 'Tu sesión ha expirado. Serás redirigido al inicio de sesión.',
        timer: 3000,
        showConfirmButton: false,
      }).then(() => {
        window.location.href = '/login';
      });
      return Promise.reject(error);
    }
    if (error.response?.status >= 500) {
      console.error('Error del servidor:', error.response.data);
      Swal.fire({
        icon: 'error',
        title: 'Error del servidor',
        text: 'Error interno del servidor. Por favor, contacta al administrador.',
        confirmButtonText: 'Entendido',
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;
